
import { defineComponent } from 'vue'

import { CCatalog } from '@/retail/contexts/product'

export default defineComponent({
  name: 'VCatalog',
  components: {
    CCatalog,
  },
})
